import { Component, OnInit } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-google-ad-modal',
  templateUrl: './google-ad-modal.component.html',
  styleUrls: ['./google-ad-modal.component.scss'],
})
export class GoogleAdModalComponent implements OnInit {
  constructor(private modalService: ModalService) {}
  private adKey = environment.production ? '/23298057242/types_banner_prod' : '23298057242/types_banner_dev'
  showLoading = true

  async ngOnInit() {
    await this.initializeRewardedAd()
    const timeout = setTimeout(() => {
      this.showLoading = false
      clearTimeout(timeout)
    }, 1000)
  }

  private async initializeRewardedAd(): Promise<void> {
    window.googletag = window.googletag || { cmd: [] }
    const googletag = window.googletag

    const existingSlot = await googletag
      .pubads()
      .getSlots()
      .find((slot) => slot.getSlotElementId() === 'div-gpt-ad-1745994062944-0')
    if (existingSlot) {
      await googletag.destroySlots([existingSlot])
    }

    googletag.cmd.push(() => {
      googletag.defineSlot(this.adKey, [320, 480], 'div-gpt-ad-1745994062944-0').addService(googletag.pubads())
      googletag.pubads().enableSingleRequest()
      googletag.enableServices()
    })

    googletag.cmd.push(() => {
      googletag.display('div-gpt-ad-1745994062944-0')
    })
  }

  onClickClose() {
    this.modalService.dismiss()
  }
}
